<template>
  <div class="userConceal">
    <Navbar title="隐私协议" :default-bg="false"/>
    <div class="text" v-html="$xss(text)"></div>
  </div>
</template>

<script>
import Navbar from "../components/NavBar";

export default {
  name: "userConceal",
  components: {Navbar},
  data() {
    return {
      text: ""
    }
  },
  created() {
    this.getUserConceal()
  },
  methods: {
    //获取用户隐私协议
    getUserConceal() {
      this.$post('article/privacy').then(result => {
        this.text = result.data;
      });
    },
  }
}
</script>

<style scoped lang="less">
.userConceal {
  .text {
    padding: 0 15px;
    box-sizing: border-box;

    p {
      padding: 0;
      margin: 0;
    }
  }
}
</style>